import { AccountsAPI } from 'api'
import { omit } from 'ramda'

export const getAllSegments = async  (params) => (
  AccountsAPI.get(`accounts/segment`, { params })
)

export const deleteSegment = async (id) => (
  AccountsAPI.delete(`accounts/segment`, {
    headers: {
      'Content-Type': 'application/json'
    },
    data: [id]
  })
)

export const getAccountsByRule = async (ruleSet, paging) => (
  AccountsAPI({
    url: `accounts/segment/accounts`,
    method: 'post',
    data: ruleSet,
    params: omit(['dir', 'property', 'filter', 'sort'], paging)
  })
)

/**
* @deprecated
* 
* returns empty response since this functionality is not supported by the API and the app does not 
* access this route
* 
*/
export const getAccountsForSegment = async (id, params) => {}